import React, { useState } from "react";

export default function Executions({ executions , selectedExecution, setSelectedExecution, handleFairnessSelect}) {
  if (!executions) {
    return (
      <div style={{ padding: "0px" }}>
        <p></p>
      </div>
    );
  }
  if (executions.length === 0){

return(
<div style={{ padding: "0px" }}>
  <div style={{ padding: '8px', fontWeight: 'bold' }}>
    Executions
  </div>

  {/* Placeholder instead of table */}
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '40vh',
      backgroundColor: 'white',
      border: '1px solid #ccc',
    }}
  >
    <div style={{ color: 'black', padding: '10px', fontWeight: 'bold' }}>
      Executions not generated due to loop
    </div>
    <select
      defaultValue=""
        onChange={(e) => {
          const value = Number(e.target.value);
          handleFairnessSelect(value);
        }}
      style={{
        padding: '8px',
        width: '80%',
        border: '1px solid #ccc',
        borderRadius: '4px',
      }}
    >
      <option value="" disabled>
        Select fairness value
      </option>
      {[1, 2, 3, 4, 5].map((val) => (
        <option key={val} value={val}>
          {val}
        </option>
      ))}
    </select>
  </div>
</div>
)
  }

  return (
    <div style={{ padding: "0px" }}>
<div style={{ padding: '8px', fontWeight: 'bold'}}>
        Executions
      </div>

       {/* Scrollable table */}
            <div
              style={{
                maxHeight: '40vh', // limits the height
                overflowY: 'auto',   // vertical scroll only
              }}
            >
      <table
        style={{
          borderCollapse: "collapse",
          width: "100%",
          background: "white",
        }}
      >
        <thead>
          <tr>
          </tr>
        </thead>
        <tbody>
          {executions.map((exec, index) => (
            <tr key={index}
            onClick={() => setSelectedExecution(exec)}
                        style={{
                          border: "1px solid black",
                          cursor: "pointer",
                          backgroundColor:
                            selectedExecution === exec ? "lightblue" : "transparent",
                        }}
            >
              <td
                style={{
                  border: "1px solid black",
                  padding: "5px",
                }}
              >
                {exec}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
        </div>
  );
}